module.exports = __webpack_public_path__ + "img/tg_02 (7).83b04a06.jpg";